import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FormatMoney } from '../../../Helpers/FormatNumber';

export const ModalModificarTotalPromociones = ({ open, handleClose, datos, ObtenerListado, reseteoFiltro }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [promocion, setPromocion] = useState({ descripcion: "", vigencia: "" });
    const handleChange = (e) => {
        setPromocion({ ...promocion, descripcion: e.target.value }); // Actualiza el valor de descripcion al escribir
    };
    const handleDateChange = (e) => {
        setPromocion({ ...promocion, vigencia: e.target.value }); // Actualiza el valor de vigencia
    };

    const onGuardar = () => {
        if (promocion.descripcion === "" || promocion.vigencia === "") {
            Swal.fire("LISTADO DE PRECIOS", "Debe llenar todos los campos", "warning");
            return;
        }

        let datosActualizados = []; // Definir fuera de los bloques para que esté disponible después

        datosActualizados = datos.map((item) => {
            return {
                ...item,
                descripcion: promocion.descripcion,
                vigencia: promocion.vigencia,
                idpromocion: item.idpromocion === null ? -99 : item.idpromocion
            };
        });

        request
            .post("Inventario/ActualizarTodasPromociones", { promoActualizadas: datosActualizados })
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                ObtenerListado();
                reseteoFiltro();
                setPromocion({
                    ...promocion,
                    descripcion: "",
                    vigencia: "",
                })
                await Swal.fire({
                    title: "LISTADO DE PRECIOS",
                    text: "promociones actualizadas",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CARGA DE EVIDENCIA", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open}>
            <div className="otros-modal">
                <LoaderScreen loader={loader} />
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>AGREGAR PROMOCION</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div className='Modal-Promociones-inputs-Container'>
                    <div className="">
                        <TextField
                            id="promocion"
                            label="Promoción"
                            type="text"
                            value={promocion?.descripcion} // Mostrar comas mientras escribe
                            onChange={handleChange}
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                    <div>
                        <TextField
                            id="vigencia"
                            label="Vigencia"
                            type="date"
                            value={promocion.vigencia}
                            onChange={handleDateChange}
                            sx={{ mb: 2, width: 540 }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                </div>
                <div className="promociones-modal-button-container">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="agregar-button"
                            onClick={onGuardar}
                            style={{ cursor: "pointer" }}>
                            Agregar
                        </div>
                    </div>
                </div>

            </div>
        </Modal>
    )
};